import { Component } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { UserinfoContactComponent } from '../../userinfo/userinfo-contact/userinfo-contact.component';
import { ScrollService } from '../../../../services/scroll.service';



@Component({
    selector: 'app-userinfo-faq-content',
    standalone: true,
    imports: [MatExpansionModule, MatDialogModule, MatButtonModule, UserinfoContactComponent],
    templateUrl: './userinfo-faq-content.component.html',
    styleUrl: './userinfo-faq-content.component.scss'
})
export class UserinfoFaqContentComponent {
  public showContactDetails = false;

  public FAQS = [
    { question: 'Kann ich die Website+App kostenlos testen?', answer: 'Ja! Du kannst die Website+App einen Monat kostenlos und unverbindlich testen. So kannst Du Dich ohne Risiko vom Mehrwert einer eigenen Website überzeugen.' },
    // { question: 'Wie schnell kann die Website+App mein Geschäft unterstützen?', answer: 'Deine Website+App kann innerhalb von 24 Stunden live geschaltet werden, nachdem Du uns grünes Licht gegeben hast. Wir arbeiten schnell und effizient, um sicherzustellen, dass Deine Website+App so schnell wie möglich online ist.' },
    { question: 'Welchen Aufwand habe ich damit?', answer: 'Unser Service ist schlüsselfertig. Das bedeutet, wir übernehmen die gesamte Einrichtung und Wartung, sodass Du Dich um nichts kümmern musst. Bei Bedarf kannst Du jedoch jederzeit Änderungen an Deiner Website+App vornehmen und diese auf Deine Bedürfnisse anpassen.' },
    { question: 'Wie kann ich das Website+App Paket bestellen?', answer: 'Schreib uns entweder per E-Mail oder ruf uns an, um Deine Bestellung aufzugeben. Alternativ lässt sich Deine Bestellung auch ganz bequem direkt auf dieser Website abschließen. Klicke hierzu einfach auf den grünen Button "Jetzt bestellen".' },
    { question: 'Wie kann ich mit euch in Kontakt treten?', answer: 'Du kannst uns jederzeit per WhatsApp, E-Mail oder telefonisch erreichen. Klicke dazu einfach auf den unteren Button "Kontaktiere uns".' },
    { question: 'Gibt es eine Mindestlaufzeit?', answer: 'Ja, die Mindestlaufzeit richtet sich nach Deiner gewählten Zahlungsoption. Bei monatlicher Zahlung beträgt die Laufzeit 1 Monat, bei jährlicher Zahlung 12 Monate. Dies ermöglicht es dir jederzeit flexibel zu bleiben.' },
    { question: 'Kommen zusätzliche Kosten auf mich zu?', answer: 'Nein, es gibt keine versteckten Kosten. Alle Preise sind transparent und klar dargestellt und es gibt keine zusätzlichen Gebühren. Du zahlst nur den vereinbarten Preis.' },
    { question: 'Was passiert nach der Mindestlaufzeit?', answer: 'Nach der Mindestlaufzeit verlängert sich Dein Vertrag automatisch um entweder einen oder 12 Monate, sofern Du nicht kündigst. Du kannst natürlich jederzeit kündigen, indem Du uns einfach kontaktierst.' },
    { question: 'Welche Zahlungsmethoden akzeptiert ihr?', answer: 'Wir akzeptieren verschiedene Zahlungsmethoden, darunter Kreditkarte, SEPA Lastschrift sowie PayPal. Wähle einfach die Option, die für Dich am bequemsten ist.' },
    { question: 'Kann ich meine Website+App selbst bearbeiten?', answer: 'Ja, Du kannst Texte und Bilder auf Deiner Website+App jederzeit selbst anpassen. Unser benutzerfreundliches System macht es Dir leicht, Änderungen vorzunehmen.' },
    { question: 'Welche Unterstützung bietet ihr an?', answer: 'Wir bieten umfassenden Support per E-Mail, WhatsApp oder Telefon an. Egal, ob Du technische Hilfe benötigst oder Fragen hast – unser Team steht Dir jederzeit zur Verfügung.' }
  ];

  constructor(
    public dialog: MatDialogRef<UserinfoFaqContentComponent>,
    public scrollService: ScrollService) { }
  
  hideContact() {
    this.showContactDetails = false;
  }

  openContact() {
    this.showContactDetails = true;
  }

  navigateToPayment() {
    this.scrollService.navigateTo('kaufen')
    this.dialog.close();
  }

}
